import React from "react"
import ReactDOM from "react-dom"
import TextAndTabsContainerComponent from "./text-and-tabs-container-component"

export default class TextAndTabsContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<TextAndTabsContainerComponent {...self.modelJson} />, self.elem)
  }
}
